import { render, staticRenderFns } from "./CustomerShowDocument.vue?vue&type=template&id=e4793bde"
import script from "./CustomerShowDocument.vue?vue&type=script&lang=js"
export * from "./CustomerShowDocument.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowDocument.vue?vue&type=style&index=0&id=e4793bde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports